import { forOwn, startCase } from 'lodash';

const Permissions = {
  READ: 'read',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
};

export const getRoleSchema = ({ roles, resources }) => {
  const props = {};
  forOwn(resources, (value) => {
    props[value] = {
      type: 'array',
      name: value,
      items: {
        type: 'string',
        enum: Object.values(Permissions),
        enumNames: Object.keys(Permissions),
      },
      uniqueItems: true,
    };
  });
  return {
    title: 'Role',
    type: 'object',
    properties: {
      role: { type: 'string', title: 'Name' },
      accessibleRoles: {
        type: 'array',
        title: 'Accessible Roles',
        items: {
          type: 'string',
          enum: roles,
          enumNames: roles.map((r) => startCase(r)),
        },
        uniqueItems: true,
      },
      permissions: {
        type: 'object',
        title: 'Permissions',
        properties: props,
      },
    },
  };
};

export const getUiSchema = (resources) => {
  const schema = {
    role: {
      'ui:readonly': true,
      classNames: 'col-md-12',
    },
    accessibleRoles: {
      'ui:widget': 'checkboxes',
      classNames: 'col-md-4',
    },
    permissions: {
      classNames: 'col-md-8',
    },
    classNames: 'col-md-12',
  };
  forOwn(resources, (value) => {
    schema.permissions[value] = {
      'ui:widget': 'checkboxes',
      classNames: 'col-md-4',
    };
  });
  return schema;
};
